var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "impact-embed-links" }, [
    _c(
      "div",
      {
        style:
          "background-color:" +
          _vm.widget.bgColor +
          "; vertical-align: middle;flex-direction: column;padding:2px 0px; display: flex; min-height: 100vh; justify-content: center;"
      },
      [
        _c(
          "div",
          { staticStyle: { display: "flex", "flex-direction": "column" } },
          [
            _c("div", { style: "font-family:" + _vm.widget.font + ";" }, [
              _c("div", {
                style:
                  "text-align: center; font-size: " +
                  _vm.widget.font_size +
                  "px;color: #000;",
                domProps: { innerHTML: _vm._s(_vm.widget.msg) }
              })
            ])
          ]
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7e974c06", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7e974c06","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/TestWidget.vue
// module id = null
// module chunks = 